import React from 'react';
import { cn } from '../../lib/utils';

const DataTable = ({ columns, rows, isFullScreen = false }) => {
  // Normalize columns to objects if they are strings
  const normalizedColumns = columns.map(col =>
    typeof col === 'string' ? { key: col, label: col } : col
  );

  return (
    <div className="w-full h-full overflow-auto custom-scrollbar">
      <table className="w-full text-left border-collapse table-auto">
        <thead className="sticky top-0 bg-white dark:bg-gray-950 z-10 transition-colors shadow-[0_1px_0_0_rgba(0,0,0,0.05)] dark:shadow-[0_1px_0_0_rgba(255,255,255,0.05)]">
          <tr>
            {normalizedColumns.map(col => (
              <th
                key={col.key}
                className={cn(
                  "pb-3 pt-2 px-4 font-black text-gray-400 uppercase tracking-widest border-b border-gray-100 dark:border-gray-800 whitespace-nowrap",
                  isFullScreen ? "text-xs pt-5 pb-4 px-8" : "text-[11px]"
                )}
              >
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-50 dark:divide-gray-900/50">
          {rows.map((row, i) => (
            <tr key={i} className="hover:bg-emerald-50/20 dark:hover:bg-emerald-900/5 transition-colors group">
              {normalizedColumns.map((col, j) => {
                const cellValue = Array.isArray(row) ? row[j] : row[col.key];
                return (
                  <td
                    key={j}
                    className={cn(
                      "font-medium text-gray-700 dark:text-gray-200 border-r border-transparent group-hover:border-emerald-50 dark:group-hover:border-emerald-900/20 last:border-r-0 whitespace-nowrap",
                      isFullScreen ? "py-5 px-8 text-sm" : "py-2.5 px-4 text-xs"
                    )}
                  >
                    {typeof cellValue === 'object' && cellValue !== null ? JSON.stringify(cellValue) : String(cellValue ?? '')}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DataTable;
